export default __webpack_public_path__ + "static/media/Good.297a87a5.svg";